import {
    Cart,
    FerryProduct,
    FlightProduct,
    HotelProduct,
    ProductType,
} from '@/api/Cart/cart.interfaces';
import { handleCustomError } from '@/config/errorHandling';
import { trackClarity } from '@/tracking/clarity';
import { ClarityEvent } from '@/tracking/clarity/types';
import store from '@/store';
import { copyProductsPax } from '@/helpers/cartCopy';

export function showCopyHotel(productId: string, cart: Cart): boolean {
    const hotels = cart.Products.filter(
        (x) => x.Type === ProductType.Hotel
    ) as HotelProduct[];

    if (hotels.length <= 1 || hotels[0].Id !== productId) {
        return false;
    }

    return true;
}

export function showCopyFlight(productId: string, cart: Cart): boolean {
    const flights = cart.Products.filter(
        (x) => x.Type === ProductType.Flight
    ) as FlightProduct[];

    if (flights.length <= 1 || flights[0].Id !== productId) {
        return false;
    }

    return true;
}

export function showCopyFerry(productId: string, cart: Cart): boolean {
    const ferries = cart.Products.filter(
        (x) => x.Type === ProductType.Ferry
    ) as FerryProduct[];

    if (ferries.length <= 1 || ferries[0].Id !== productId) {
        return false;
    }

    return true;
}

export function copyHotels(productId: string): boolean {
    const products = store.getters['cart/getHotelProducts'] as HotelProduct[];
    const source = products.find((x) => x.Id === productId);
    if (source) {
        const updatedProducts = copyProductsPax(source, products);
        store.dispatch('cart/updateProducts', updatedProducts);
        trackClarity(ClarityEvent.CHECKOUT_COPY_HOTEL);
        return true;
    } else {
        handleCustomError('Error when trying to copy room names');
        trackClarity(ClarityEvent.CHECKOUT_COPY_HOTEL_ERROR);
        return false;
    }
}

export function copyFlights(productId: string): boolean {
    const products = store.getters['cart/getFlightProducts'] as FlightProduct[];
    const source = products.find((x) => x.Id === productId);

    if (source) {
        const updatedProducts = copyProductsPax(source, products);
        store.dispatch('cart/updateProducts', updatedProducts);
        trackClarity(ClarityEvent.CHECKOUT_COPY_FLIGHT);
        return true;
    } else {
        handleCustomError('Error when trying to copy flight names');
        trackClarity(ClarityEvent.CHECKOUT_COPY_FLIGHT_ERROR);
        return false;
    }
}

export function copyFerries(productId: string): boolean {
    const products = store.getters['cart/getFerryProducts'] as FerryProduct[];
    const source = products.find((x) => x.Id === productId);

    if (source) {
        const updatedProducts = copyProductsPax(source, products);

        store.dispatch('cart/updateProducts', updatedProducts);
        trackClarity(ClarityEvent.CHECKOUT_COPY_FERRY);
        return true;
    } else {
        handleCustomError('Error when trying to copy ferry names');
        trackClarity(ClarityEvent.CHECKOUT_COPY_FERRY_ERROR);
        return false;
    }
}
